<template>
  <div class="modal fade" id="modalPointVaucher" role="dialog">
    <div class="modal-dialog modal-dialog-35" v-bind:style="{'width': width}">
      <!-- Modal content-->
      <div class="modal-content modal-point-vaucher">
        <div class="modal-header">
          <button type="button" class="close" @click="closeModal()" data-dismiss="modal">&times;</button>
          <span>Comprovante do dia</span>
        </div>
        <div class="modal-body">
          <div class="body-header">
            <span>Comprovante de ponto do dia</span>
            <span class="header-date">{{ dataModalContent.data.pointReference | formatDate }}</span>
            <span>{{ dataModalContent.data.company.representationName }}</span>
            <span>CNPJ: {{ dataModalContent.data.company.document | cpfOrCnpj }}</span>
            <span>Registro INPI: {{ dataModalContent.data.inpiRegister }}</span>
          </div>
          <div class="body-content">
            <span v-for="(points, index) in dataModalContent.data.days" class="content-points" :key="index">
              <span class="point-title">Ponto {{ index + 1 }}: <span>{{ points.data.day }} às {{ points.data.hour }}</span></span>
              <span>Local: {{ points.data.local }}</span>

              <span class="point-code" :style="points.viewMore ? 'display: block;' : 'display: flex;'">Código: <span :class="!points.viewMore ? 'hide-code' : ''">{{ points.asignHashPoint}}</span>
                <span v-if="points.viewMore" class="more-less" @click="viewMoreLess(points)">Ver menos</span>
                <span v-else class="more-less" @click="viewMoreLess(points)">Ver Mais</span>
              </span>

            </span>
          </div>
          <div class="body-collaborator">
            <span class="collaborator-name">Colaborador: <span>{{ dataModalContent.data.employee.name }}</span></span>
            <span>({{ dataModalContent.data.employee.cpf }})</span>
          </div>
          <div class="body-signature">
            <span class="signature-title">Assinatura eltrônica:</span>
            <span class="signature-id" :style="!viewMoreSign ? 'display: flex;' : 'display: block;'">
              <span :class="!viewMoreSign ? 'hide-code' : ''">{{ dataModalContent.asignHash }}</span>
              <span class="more-less" @click="viewMoreLessSign(!viewMoreSign)">{{ viewMoreSign ? 'Ver Menos' : 'Ver Mais' }}</span>
            </span>
            <span class="signature-reference">Referência: <span>{{ dataModalContent.data.employee.reference }}</span></span>
          </div>
          <div class="footer-body">
            <svg width="327" height="16" viewBox="0 0 327 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.5" d="M8.86445 16L-4.34089e-06 1.29135e-06L17.7289 2.86102e-06L8.86445 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M27.0858 16L17.7289 1.21428e-06L36.4428 2.86102e-06L27.0858 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M45.7997 16L36.4428 1.21428e-06L55.1566 2.86102e-06L45.7997 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M64.5136 16L55.1566 1.21428e-06L73.8705 2.86102e-06L64.5136 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M82.7349 16L73.8705 1.30095e-06L91.5994 2.86102e-06L82.7349 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M100.464 16L91.5994 1.30095e-06L109.328 2.86102e-06L100.464 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M118.193 16L109.328 1.29135e-06L127.057 2.86102e-06L118.193 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M135.922 16L127.057 1.29135e-06L144.786 2.86102e-06L135.922 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M154.143 16L144.786 1.21428e-06L163.5 2.86102e-06L154.143 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M172.857 16L163.5 1.21428e-06L182.214 2.86102e-06L172.857 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M191.078 16L182.214 1.30095e-06L199.943 2.86102e-06L191.078 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M208.807 16L199.943 1.30095e-06L217.672 2.86102e-06L208.807 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M226.536 16L217.672 1.30095e-06L235.401 2.86102e-06L226.536 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M244.265 16L235.401 1.30095e-06L253.13 2.86102e-06L244.265 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M262.486 16L253.13 1.21428e-06L271.843 2.86102e-06L262.486 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M281.2 16L271.843 1.21428e-06L290.557 2.86102e-06L281.2 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M299.914 16L290.557 1.21428e-06L309.271 2.86102e-06L299.914 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M318.136 16L309.271 1.30095e-06L327 2.86102e-06L318.136 16Z" fill="#FFE268"/>
            </svg>
          </div>
        </div>
        <div v-if="sendEmailDisplay" class="body-email">
          <div class="email-input">
            <label>
              Enviar para o e-mail <span>*</span>
            </label>
            <input v-model="valueEmail" type="text" placeholder="Digite o seu E-mail">
            <span v-if="validateInputEmail" class="validate-input">
              Preencha um e-mail *
            </span>
          </div>
          <div class="email-btn">
            <span @click="statusEmail(false)" class="btn-cancel">Cancelar</span>
            <button @click="sendEmail()" class="btn-send" :disabled="loadingEmail">
              <div v-if="loadingEmail" class="loading-btn">
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5">
                  </div>
                </div>
              </div>
              <div v-else class="btn-group">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 8L9.125 1.4375V5.1875C2.5457 5.1875 1 9.90508 1 14.5625C2.89883 12.1312 4.57812 10.8125 9.125 10.8125V14.5625L16 8Z" stroke="white" stroke-linejoin="round"/>
                </svg>
                Enviar
              </div>
            </button>
          </div>
        </div>
        <button v-else @click="statusEmail(true)" class="send-email" >
          <div class="email-group">
            <ion-icon name="mail-outline"></ion-icon>
            Enviar por e-mail
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {REQUEST_SERVICE} from "../../../requestConfig";
import {GET_POINT_VOUCHER_EMAIL} from "../../../urlConfig";
import {UTIL_SERVICE} from "../../../utils";
import swal from "sweetalert";

export default {
  name: "modalPointVaucher",
  props: {
    dataModal: {
      required: true
    },
    idDay: {
      required: false,
    }
  },
  data() {
    return {
      width: '100%',
      dataCodeVaucher: '',
      loadingEmail: false,
      sendEmailDisplay: false,
      valueEmail: '',
      validateInputEmail: false,
      dataModalContent: {
        asignHash: '',
        data: {
          company: {
            representationName: '',
            document: '',
          },
          days: [
            {
              data: {
                day: '',
                hour: '',
                local: ''
              },
              asignHashPoint: ''
            }
          ],
          employee: {
            name: '',
            reference: '',
          },
          pointReference: '',
          inpiRegister: '',
        },
      },
      viewMoreSign: false,
    }
  },
  methods: {
    closeModal() {
      this.sendEmailDisplay = false;
      this.valueEmail = '';
      $('#modalPointVaucher').modal('hide');
    },
    statusEmail(value) {
      this.sendEmailDisplay = value;
    },
    sendEmail() {
      if(this.valueEmail === '') {
        return this.validateInputEmail = true
      }

      const validateEmail = function (value) {
        const regex =  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(value);
      }

      if (!validateEmail(this.valueEmail)) {
        return swal({
          title: "Não foi possível enviar para este e-mail",
          text: "Parece que esse é um e-mail inválido, digite outro e-mail e tente novamente.",
          icon: "warning",
          button: "Entendi!",
        });
      }

      this.loadingEmail = true;

      let idDay = ''

      if(this.idDay) {
        idDay = this.idDay;
      }

      REQUEST_SERVICE.get(GET_POINT_VOUCHER_EMAIL + idDay + '?email=' + this.valueEmail)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_POINT_VOUCHER_EMAIL:", response.data);

          if(response.data.emailsucess) {
            this.closeModal();

            swal({
              title: "Sucesso!",
              text: "E-mail enviado com sucesso!",
              icon: "success",
            });
          } else {
            swal({
              title: "Não foi possível enviar para este e-mail",
              text: "Parece que esse é um e-mail inválido, digite outro e-mail e tente novamente.",
              icon: "warning",
              button: "Entendi!",
            });
          }

          this.loadingEmail = false;

        }).catch(reason => {
        this.loadingEmail = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
        UTIL_SERVICE.console("RESULT ERROR:", reason.data);
      });
    },
    viewMoreLess(points) {
      points.viewMore = !points.viewMore
    },
    viewMoreLessSign(value) {
      this.viewMoreSign = value;
    }
  },
  watch : {
    dataModal: function (val) {
      this.dataModalContent = val;
    },
  }
}
</script>

<style lang="scss">

.swal-text {
  text-align: center;
}

.hide-code {
  display: list-item;
  width: 70%;
  white-space: nowrap;
  overflow: hidden!important;
  text-overflow: ellipsis;
}

.modal-dialog {
  max-width: 387px;

  @media only screen and (max-width: 520px) {
    max-width: 96%;
    min-width: 96%;
  }
}

.modal-point-vaucher {
  padding: 30px;
  box-shadow: none;
  border: none;
  border-radius: 8px;

  .modal-header {
    padding: 0 0 10px 0;
    border-bottom: 1px solid var(--bodyColor);

    .close {
      top: 10px;
      right: 10px;
    }

    span {
      color: var(--titleBox);
      font-size: 24px;
      font-weight: 700;
      line-height: 31.2px;
    }
  }

  .modal-body {
    margin-top: 16px;
    padding: 16px;
    background: #FFF0B4;
    position: relative;

    .body-header {
      display: flex;
      flex-direction: column;
      align-items: center;

      font-size: 17px;
      font-weight: 400;
      line-height: 23.91px;
      color: #191919;

      .header-date {
        font-weight: 700;
        margin-bottom: 16px;
      }
    }

    .body-content {
      margin-top: 26px;
      padding-top: 18px;
      border-top: 1px dashed #191919;
      border-bottom: 1px dashed #191919;
      margin-bottom: 18px;

      .content-points {
        display: flex;
        flex-direction: column;
        word-break: break-all;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 18px;
        }

        .point-title {
          font-size: 14px;
          font-weight: 400;
          line-height: 19.69px;

          span {
            font-size: 14px;
            font-weight: 700;
          }
        }

        .point-code {
          display: flex;

          span {
            margin-left: 3px;
          }

          .more-less {
            color: var(--text);
            cursor: pointer;
            font-size: 10px;
            font-weight: 400;
            line-height: 14.06px;
            margin: 0;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        span {
          color: #191919;
          font-size: 10px;
          font-weight: 400;
          line-height: 14.06px;
        }
      }
    }

    .body-collaborator {
      display: flex;
      flex-direction: column;
      word-break: break-all;
      border-bottom: 1px dashed #191919;
      margin-bottom: 10px;
      padding-bottom: 18px;

      .collaborator-name {
        font-size: 14px;
        font-weight: 400;
        line-height: 19.69px;
        color: #191919;

        span {
          font-size: 14px;
          font-weight: 700;
        }
      }

      span {
        font-weight: 700;
        font-size: 14px;
      }
    }

    .body-signature {
      display: flex;
      flex-direction: column;
      word-break: break-all;

      .signature-title {
        font-size: 10px;
        font-weight: 400;
        line-height: 14.06px;
        color: #191919;
      }

      .signature-id {
        font-size: 10px;
        font-weight: 400;
        line-height: 14.06px;
        color: #191919;
        margin-bottom: 8px;

        .more-less {
          color: var(--textActiveSide);
          cursor: pointer;
          font-size: 10px;
          font-weight: 400;
          line-height: 14.06px;
          margin: 0 0 0 6px;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .signature-reference {
        font-size: 14px;
        font-weight: 400;
        line-height: 19.69px;
        color: #191919;

        span {
          font-size: 14px;
          font-weight: 700;
        }
      }
    }

    .footer-body {
      position: absolute;
      bottom: -21px;
      left: 0;
      width: 100%;

      svg {
        path {
          fill: #FFF0B4;
          opacity: 1;
        }
      }
    }
  }

  .send-email {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--linkColor);
    color: var(--linkColor);
    padding: 12px 0;
    border-radius: 4px;
    transition: .2s;
    background: var(--cardBackground);
    margin-top: 32px;

    &:hover {
      background: var(--linkColor);
      color: var(--cardBackground);

      .loading-btn {
        .rect1, .rect2, .rect3, .rect4, .rect5 {
          background: var(--cardBackground);
        }
      }
    }

    .email-group {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      background: transparent;

      ion-icon {
        font-size: 20px;
        margin-right: 4px;
      }
    }

    .loading-btn {
      .rect1, .rect2, .rect3, .rect4, .rect5 {
        background: var(--linkColor);
      }
    }

    &:disabled {
      cursor: no-drop;
      filter: grayscale(1);
      opacity: 50%;

      .loading-btn {
        .rect1, .rect2, .rect3, .rect4, .rect5 {
          background: var(--linkColor);
        }
      }

      &:hover {
        background: transparent;
      }
    }
  }

  .body-email {
    margin-top: 32px;

    .email-input {
      position: relative;

      label {
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        color: var(--defaultText);

        span {
          color: var(--redColor);
        }
      }

      input {
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        line-height: 22.5px;
        border-radius: 4px;
        padding: 6px 12px;
        background: var(--bodyColor);
        color: var(--textSide);

        &::placeholder {
          color: var(--textSide);
        }
      }

      .validate-input {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 12px;
        font-weight: 400;
        color: var(--redColor);
      }
    }

    .email-btn {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;

      .btn-cancel {
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        padding: 12px 26px;
        background: var(--defaultText);
        cursor: pointer;
        transition: .2s;
        border-radius: 4px;
        margin-right: 15px;

        &:hover {
          background: #6b7380;
        }
      }

      .btn-send {
        background: var(--linkColor);
        border: none;
        color: #FFFFFF;
        padding: 0 27px;
        border-radius: 4px;
        transition: .2s;

        &:hover {
          background: #2c2588;
        }

        .btn-group {
          display: flex;
          align-items: center;

          svg {
            margin-right: 6px;

            path {
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/views/modals/modalPointVaucher.vue